import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=ab2d572c"
import script from "./TeacherEdit.vue?vue&type=script&lang=js"
export * from "./TeacherEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports